<template>
  <div>
    <div class="rj-page-card">
      <div class="rj-page-card__title">
        上传L/C原件
      </div>
      <div class="rj-page-card__content">
        <div style="margin-top: 20px">
          <el-upload
            action=""
            multiple
            :show-file-list="false"
            :http-request="uploadaction"
          >
            <el-button type="primary">
              选择附件
            </el-button>
          </el-upload>
        </div>
        <ul class="el-upload-list el-upload-list--text" style="margin: 10px 0">
          <el-row :gutter="60">
            <el-col v-for="(item ,index) in fileList" v-show="item.loading" :key="index" :span="9" class="el-col-auto">
              <li tabindex="0" class="el-upload-list__item is-success">
                <a class="el-upload-list__item-name">
                  <i class="el-icon-document" />
                  {{ item.enclosureName }}
                </a>
                <label v-if="!item.loading" class="el-upload-list__item-status-label">
                  <i class="el-icon-upload-success el-icon-circle-check" />
                </label>
                <el-progress v-if="item.loading" style="margin-top: 5px" :percentage="item.percentage" :stroke-width="4" :show-text="false" />
              </li>
            </el-col>
          </el-row>
        </ul>
        <el-table v-loading="tableLoading" :data="tableData" border style="width: 100%" row-key="id">
          <el-table-column prop="fileName" label="文件名称" align="left">
            <template v-slot="{row}">
              <el-button type="text" @click="openContract(row.fileToken)">
                {{ row.fileName }}
              </el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="createBy" label="上传人" align="left" />
          <el-table-column prop="createTime" label="上传时间" align="left" /> -->
          <el-table-column prop="pname" label="操作" align="left" fixed="right" width="200">
            <template v-slot="{row,$index}">
              <el-button slot="reference" type="text" style="color: #F56C6C;" @click="removeFile(row,$index)">
                删除
              </el-button>
              <el-button type="text" style="margin-left: 10px" @click="downOneFile(row.fileToken)">
                下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
  </div>
</template>
<script type="es6">
import axios, { attachmentGetToken, electronicSignature, printContractPDF, getUrlByFileID } from '@/API';
export default {
  data () {
    return {
      tableData: [],
      multipleSelection: [],

      fileList: [],
      tableLoading: false,
      uploadUrl: '',
      downFileUrl: '',
      token: '',
      fileserveDownUrl: ''
    };
  },
  components: {
  },
  computed: {},
  methods: {
    initToken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch((err) => {
        console.log(err);
      });
    },

    downOneFile (id) {
      this.fileserveDownUrl = this.downFileUrl + `/${id}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    downzipFile (token, url) {
      this.fileserveDownUrl = url + `?Token=${token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    uploadaction (upload) {
      let form = new FormData(); // 创建form对象
      form.append('files', upload.file);
      let myfile = {
        enclosureName: upload.file.name,
        loading: true,
        percentage: 0
      };
      this.fileList.push(myfile);
      axios.post(this.uploadUrl + `?Token=${this.token}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          myfile.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          myfile.loading = false;
          myfile.status = 'success';
          this.tableData.push({
            fileName: json.data[0].FullName,
            fileToken: json.data[0].FID,
            isLc: 1
          });
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          myfile.loading = false;
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch(() => {
        myfile.loading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
    },
    removeFile (row, index) {
      this.tableData.splice(index, 1);
    },
    goEsing () {
      electronicSignature(this.contractNum).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$refs.doEsign.openWindow(json.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    printPdf () {
      printContractPDF(this.contractNum).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.fileserveDownUrl = `/pdf/web/viewer.html?file=${encodeURIComponent(json.data)}`;
          this.$nextTick(() => {
            this.$refs.downTag.click();
          });
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    openContract (fileToken) {
      getUrlByFileID(fileToken).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          window.open(json.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  mounted () {
    // this.searchFiles();
    this.initToken();
  }
};
</script>
